const ARABIC_SCRIPT = /[؀-ۿݐ-ݿࢠ-ࣿ]/;
const DEFINITE_ARTICLE = /^(ال|أل)(?=\p{L}{2,})/u;

export function isArabicScript(text: string): boolean {
  return ARABIC_SCRIPT.test(text);
}

function firstLetter(word: string): string {
  const match = word.match(/\p{L}/u);
  return match ? match[0] : '';
}

/**
 * Avatar initials (design system §4.12):
 * Latin → first letters of first and last word ("Layla Ahmad" → "LA").
 * Arabic → first letter of first name and of the last word without «ال» ("ليلى السيد" → «ل س»).
 * Single word → first letter only. Scripts are never mixed.
 */
export function initialsOf(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const first = words[0];
  if (!first) return '';
  const last = words.length > 1 ? words[words.length - 1] : undefined;
  if (isArabicScript(first)) {
    const a = firstLetter(first);
    if (!last) return a;
    const b = firstLetter(last.replace(DEFINITE_ARTICLE, ''));
    return b ? `${a} ${b}` : a;
  }
  const a = firstLetter(first).toLocaleUpperCase();
  const b = last ? firstLetter(last).toLocaleUpperCase() : '';
  return `${a}${b}`;
}

/** Stable small hash for deterministic avatar colours. */
export function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
}
